// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";

import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import { store } from "./store/store";
import Vuelidate from "vuelidate";
import { apolloProvider } from "./constants/apollo-provider";

//for subscriptions

//import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";
import "material-design-icons-iconfont/dist/material-design-icons.css";
//import "@mdi/font/css/materialdesignicons.css";
Vue.use(Vuelidate);

import VueColumnsResizableVuetify from "vue-columns-resizable-vuetify";
Vue.use(VueColumnsResizableVuetify);

//global filters
var moment = require("moment");
Vue.filter("formatDate", function (value) {
  var format = "DD-MM-YYYY";
  if (store.getters.userConfig) {
    format = store.getters.userConfig.dateFormat;
  }
  return value ? moment(value).startOf("day").format(format) : "";
});
Vue.filter("formatDateTime", function (value) {
  var format = "DD-MM-YYYY";
  if (store.getters.userConfig) {
    format = store.getters.userConfig.dateFormat;
  }
  return moment(value).format(`${format} HH:mm:ss`);
});
Vue.filter("priceLabeler", (price) =>
  isNaN(Number(price))
    ? price
    : Number(Number(price).toFixed(2)).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
);

Vue.config.productionTip = false;

Vue.use(Vuetify);

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAUJX8TrUz2compJ8ls308IG3v14x2UPLM",
    libraries: "geometry", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.config.errorHandler = (err, vm, info) => {
  //quiet down some annoiyng vuetifyjs errors
  if (err != "TypeError: Cannot read property 'clientHeight' of undefined") {
    console.error(err);
  }
};

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

new Vue({
  el: "#app",
  router,
  store,
  apolloProvider,
  components: { App },
  template: "<App/>",
  vuetify: new Vuetify({
    icons: {
      iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    breakpoint: {
      thresholds: {
        xs: 340,
        sm: 540,
        md: 800,
        lg: 1920,
      },
      scrollBarWidth: 24,
    },
  }),
});

//mmovable hack
(function () {
  // make vuetify dialogs movable
  const d = {};
  document.addEventListener("mousedown", (e) => {
    const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
    //fix to hide active dropdowns when moving dialog
    const activeMenu = document.querySelector(".menuable__content__active");

    if (
      e.button === 0 &&
      closestDialog != null &&
      e.target.classList.contains("draggable")
    ) {
      // element which can be used to move element
      if (activeMenu) {
        activeMenu.style.display = "none";
      }
      d.el = closestDialog; // element which should be moved
      d.mouseStartX = e.clientX;
      d.mouseStartY = e.clientY;
      d.elStartX = d.el.getBoundingClientRect().left;
      d.elStartY = d.el.getBoundingClientRect().top;
      d.el.style.position = "fixed";
      d.el.style.margin = 0;
      d.oldTransition = d.el.style.transition;
      d.el.style.transition = "none";
    }
  });
  document.addEventListener("mousemove", (e) => {
    if (d.el === undefined) return;
    d.el.style.left =
      Math.min(
        Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
        window.innerWidth - d.el.getBoundingClientRect().width
      ) + "px";
    d.el.style.top =
      Math.min(
        Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
        window.innerHeight - d.el.getBoundingClientRect().height
      ) + "px";
  });
  document.addEventListener("mouseup", () => {
    if (d.el === undefined) return;
    d.el.style.transition = d.oldTransition;
    d.el = undefined;
  });
  setInterval(() => {
    // prevent out of bounds
    const dialog = document.querySelector(".v-dialog.v-dialog--active");
    if (dialog === null) return;
    dialog.style.left =
      Math.min(
        parseInt(dialog.style.left),
        window.innerWidth - dialog.getBoundingClientRect().width
      ) + "px";
    dialog.style.top =
      Math.min(
        parseInt(dialog.style.top),
        window.innerHeight - dialog.getBoundingClientRect().height
      ) + "px";
  }, 100);
})();



// WEBPACK FOOTER //
// ./src/main.js